import React, { useState } from "react";
import styles from "./songratingbuttons.module.scss";
import { logEvent } from "analyticsEvents";
import { Box } from "@material-ui/core";


interface Props {
  songId: string,
  onValueChanged: (newRating: number|null) => void
}

const SongRatingButtons = (props: Props) => {
  const [value, setValue] = useState<number|null>(null);

  const onButtonClicked = (value: number|null) => {
    setValue(value);
    props.onValueChanged(value);
    if (value === null) {
      logEvent('rating_cleared', {
        song_id: props.songId,
        rating_ui_variant: 'buttons'
      });
    } else {
      logEvent('rating_button_pressed', {
        song_id: props.songId,
        rating_position: value,
        rating_ui_variant: 'buttons'
      });
    }
  };

  return (
    <Box display='flex' flexDirection='column' alignItems='center'>
      <div hidden={value !== null} className={styles.rateItText}><p>RATE IT!</p></div>
      <div className={styles.ratingButtonRow} hidden={value !== null}>
        {ratingButton(0, onButtonClicked)}
        {ratingButton(2.5, onButtonClicked)}
        {ratingButton(5, onButtonClicked)}
        {ratingButton(7.5, onButtonClicked)}
        {ratingButton(10, onButtonClicked)}
      </div>
      <button className={styles.ratingSelectedCircle}
          hidden={value === null}
          onClick={() => onButtonClicked(null)}>
        {emojiForValue(value || 0)}
      </button>
      <div hidden={value === null} className={styles.hearMoreText}><p>Wanna hear more?</p></div>
    </Box>
  )
}

const ratingButton = (value: number, onClick: (value: number) => void) => {
  return (
    <button onClick={() => onClick(value)} className={styles.ratingButton}>{emojiForValue(value)}</button>
  )
}

const emojiForValue = (value: number) => {
  if (value < 2.5) return "💩";
  if (value < 5) return "🤷";
  if (value < 7.5) return "🌶️";
  if (value < 10) return "⛽";
  return "🔥";
}

export default SongRatingButtons
